import { Environment } from '../../../../environment';
import { Apiesolicitacao, Apiestoque } from '../../estoque/axiosestoque';

export interface IListagemLocalizacao {
  idlocalizacao: string;
  descricao: string;
  dataenvio?: Date;
  notificacao: string;
}
interface IDetalheLocalizacao {
  idlocalizacao?: string;
  descricao: string;
  dataenvio?: Date;
}
type TComTotalCount = {
    data: IListagemLocalizacao[];
    totalCount: number;
}
type TComTotalCountlocalizacao = {
    data: IListagemLocalizacao[];
}
const getAll = async (page = 1, filter = '', token: string): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa = `/localizacao?page=${page}&limit=${200}&filter=${filter}`;
    const { data, headers } = await Apiestoque.get(urlRelativa, {
      headers: {
        'Authorization': `Bearer ${token}` 
      }
    });
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getAllMenu = async (): Promise<TComTotalCountlocalizacao | Error> => {
  try {
    const urlRelativa = `/localizacao`;
    const { data } = await Apiesolicitacao.get(urlRelativa);
    if (data) {
      return {
        data,
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getAllList = async (filter = '', id = ''): Promise<TComTotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ? `/localizacaolist?limit=${Environment.LIMITE_DE_LINHAS}&filter=${filter}` : `/localizacaolist/${id}` ;
    const { data, headers } = await Apiestoque.get(urlRelativa);
    if (data) {
      return { 
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};
const getById = async (id: string): Promise<IDetalheLocalizacao | Error> => {
  try {
    const { data } = await Apiesolicitacao.get(`/localizacao/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};
const create = async (
  dados: IDetalheLocalizacao[],
  token: string
): Promise<string[] | Error> => {
  try {
    const localizacoesComIds = dados.map((item) => ({
      ...item,
      idlocalizacao: item.idlocalizacao,
    }));
    const { data } = await Apiesolicitacao.post<IDetalheLocalizacao[]>(
      "/localizacao",
      localizacoesComIds,
      {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      }
    );
    if (Array.isArray(data) && data.length > 0) {
      return data.map((item) => item.idlocalizacao!); 
    }
    return new Error("Nenhum registro foi criado.");
  } catch (error) {
    return new Error(
      (error as { message: string }).message || "Erro ao criar os registros."
    );
  }
};
const updateById = async (id: string, dados: IDetalheLocalizacao): Promise<void | Error> => {
  try {
    await Apiestoque.put(`/localizacao/${id}`, dados);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Apiestoque.delete(`/localizacao/${id}`);
  } catch (error) {
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};
export const LocalizacaoService = {
  getAll,
  getAllList,
  create,
  getById,
  updateById,
  deleteById,
  getAllMenu,
};